import { toast } from 'react-toastify';
import { TOAST_CONFIG, TOAST_IDS } from '../const';
import { logger } from '../utils/logger';

export const handleErrorToast = (error, customId) => {
  if (error) {
    toast.dismiss();
    toast.error(error, {
      ...TOAST_CONFIG,
      toastId: customId || TOAST_IDS.ERROR,
    });
  }
};

export const handleSuccessToast = (message, customId) => {
  if (message) {
    toast.dismiss();
    toast.success(message, {
      ...TOAST_CONFIG,
      toastId: customId || TOAST_IDS.SUCCESS,
    });
  }
};

export const handleWarningToast = (message, customId) => {
  if (message) {
    toast.dismiss();
    toast.warning(message, {
      ...TOAST_CONFIG,
      toastId: customId || TOAST_IDS.WARNING,
    });
  }
};

export const handleInfoToast = (message, customId) => {
  if (message) {
    toast.dismiss();
    toast.info(message, {
      ...TOAST_CONFIG,
      toastId: customId || TOAST_IDS.INFO,
    });
  }
};

export const getErrMsgFromResp = (err) => {
  logger.log('getErrMsgFromResp', err);
  let errmsgFallback = 'Something went wrong!';
  let errmsg = '';
  logger.log('err?.response?.data?.message', err?.response?.data?.message);
  if (
    err?.response?.data &&
    err?.response?.data?.message !== undefined &&
    err?.response?.data?.message !== ''
  ) {
    logger.log('err?.response?.data?.message', err?.response?.data?.message);
    errmsg = err.response.data.message;
  } else if (
    err?.status &&
    err?.data &&
    err?.data?.message !== undefined &&
    err?.data?.message !== '' &&
    errmsg === ''
  ) {
    logger.log('err?.data?.message', err?.data?.message);
    errmsg = err.data.message;
  } else if (err?.errors?.[0]?.message && errmsg === '') {
    logger.log('err?.errors?.[0]?.message', err?.errors?.[0]?.message);
    errmsg = err?.errors?.[0]?.message;
  }
  if (errmsg === '') {
    errmsg = errmsgFallback;
  }
  logger.log('errmsg', errmsg);
  return errmsg;
};

export const getErrCodeFromResp = (err) =>
  err?.response?.data?.errorCode ||
  err?.data?.errorCode ||
  err?.errors?.[0]?.extensions?.errorCode ||
  '';
